<template>
  <v-row
    align="center"
  >
    <v-col
      cols="12"
      class="banner"
    >
      <v-carousel
        v-if="bannerUrl.length!==0"
        :show-arrows="bannerUrl.length!==1"
        hide-delimiters
        cycle
        height="auto"
        style="border-radius: 12px;"
      >
        <div
          v-for="(item,i) in bannerUrl"
          :key="i"
        >
          <v-carousel-item
            class="c-banner"
            eager
          >
            <img
              :src="item.link_url"
              height="100%"
              eager
            />
          </v-carousel-item>
        </div>
      </v-carousel>
    </v-col>
  </v-row>
</template>

<script>
import { anonymous as apiAnonymous } from '@/apis' 

export default {
  data: () => ({
    bannerUrl : [],
  }),
  async mounted () {
    this.getBanner()
  },
  methods:{ 
    async getBanner () { 
      const [err, data,] =  await apiAnonymous.getBanners({ type_id: 2 })
      
      if(err) {
        return
      }

      this.bannerUrl = data
    },
  }
}
</script>
<style scoped>
.c-banner >>> .v-image__image {
  background-size: contain;
}

</style>